import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { aiProactivePluginKey } from '../../pm-plugins/ai-proactive/ai-proactive-plugin-key';
import type { AIProactivePluginState } from '../../pm-plugins/ai-proactive/states';

export const useProactivePluginState = (editorView: EditorView): AIProactivePluginState => {
	const pluginState = aiProactivePluginKey.getState(editorView.state);
	return pluginState;
};
